'use es6';

import { STEPS } from 'FormsUI/constants/NavigationSteps';
import { getV2EditorRoute } from 'FormsUI/lib/RouteGenerators';
import { getFormGuid } from 'FormsUI/selectors/FormDefinition';
import { getSelectedFormItemType } from 'FormsUI/selectors/FormSelection';
import { push } from 'FormsUI/actions/HistoryActions';
import { getSupportedFormFieldTypeOrText } from 'FormsUI/utils/FormFieldsUtils';
import { getFieldUrlPath, parseFieldUrlPath } from 'FormsUI/utils/FormSelectionUtils';
import { getPropertyObjectTypeId } from 'FormsUI/utils/PropertiesUtils';
function createAction(name) {
  return `@@formSelection/${name}`;
}
export const SELECT_FORM_ITEM = createAction('SELECT_FORM_ITEM');
export const RESET_SELECTED_FORM_ITEM = createAction('RESET_SELECTED_FORM_ITEM');
export function updateSelectedFormItemAction(formItemType, formItemReference) {
  return {
    type: SELECT_FORM_ITEM,
    formItemType,
    formItemReference
  };
}
export function resetSelectedFormItemAction() {
  return {
    type: RESET_SELECTED_FORM_ITEM
  };
}
export const updateSelectedFormItemRoute = (formItemType, formItemReference) => (dispatch, getState) => {
  const state = getState();
  const formGuid = getFormGuid(state);
  const field = getFieldUrlPath({
    formItemType,
    formItemReference
  });
  dispatch(push(getV2EditorRoute(formGuid, STEPS.FORM, undefined, {
    field
  })));
};
export const resetSelectedFormItem = ({
  updateRoute = false
} = {}) => (dispatch, getState) => {
  const state = getState();
  const formGuid = getFormGuid(state);
  if (updateRoute) {
    dispatch(push(getV2EditorRoute(formGuid, STEPS.FORM)));
  }
  dispatch(resetSelectedFormItemAction());
};
export const resetSelectedFormItemIfNeeded = () => (dispatch, getState) => {
  const state = getState();
  const formGuid = getFormGuid(state);
  const currentPath = window.location.pathname;
  const editorUrlRoute = getV2EditorRoute(formGuid, STEPS.FORM);
  const notOnV2EditorUrlRoute = currentPath !== editorUrlRoute;
  dispatch(resetSelectedFormItem({
    updateRoute: notOnV2EditorUrlRoute
  }));
};
export const updateSelectedFormItem = (formItemType, formItemReference, {
  updateRoute = true
} = {}) => dispatch => {
  dispatch(updateSelectedFormItemAction(formItemType, formItemReference));
  if (updateRoute) {
    dispatch(updateSelectedFormItemRoute(formItemType, formItemReference));
  }
};
export const updateSelectedByFormField = (formField, updateRoute = true) => dispatch => {
  const fieldType = getSupportedFormFieldTypeOrText(formField);
  dispatch(updateSelectedFormItem(fieldType, getPropertyObjectTypeId(formField), {
    updateRoute
  }));
};
export const selectFormItemByRoute = fieldUrlPath => (dispatch, getState) => {
  const {
    formItemReference
  } = parseFieldUrlPath(fieldUrlPath);
  const formItemType = getSelectedFormItemType(getState());
  dispatch(updateSelectedFormItem(formItemType, formItemReference, {
    updateRoute: false
  }));
};